import React, { useCallback, useState } from "react";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DataTable from "components/Tables/DataTable/DataTable";
import TableSkeleton from "components/TableSkeleton/TableSkeleton";
import useDailyInspectionsTable from "hooks/fleet/useDailyInspectionsTable";
import QuestionsModal from "components/fleet/QuestionsModal";
import CreateDailyInspectionModal from "components/fleet/CreateDailyInspectionModal";
import EditDailyInspectionModal from "components/fleet/EditDailyInspectionModal";
import { Grid } from "@mui/material";

export default function DailyInspectionsPage() {
  const [questionsModalOpen, setQuestionsModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedInspectionId, setSelectedInspectionId] = useState<string>("");

  const handleEditClick = useCallback((inspectionId: string) => {
    setSelectedInspectionId(inspectionId);
    setEditModalOpen(true);
  }, []);

  const handleEditModalClose = useCallback(() => {
    setEditModalOpen(false);
    setSelectedInspectionId("");
  }, []);

  const { loading, error, tableData, pagination, filtering, sorting } =
    useDailyInspectionsTable(handleEditClick);

  return (
    <DashboardPage>
      <MDBox mb={3}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MDTypography variant="h4" fontWeight="medium">
              Daily Inspections
            </MDTypography>
          </Grid>
          <Grid item xs={12} lg={6} display="flex" justifyContent="flex-end" gap={2}>
            <MDButton variant="text" color="info" onClick={() => setQuestionsModalOpen(true)}>
              Manage questions
            </MDButton>
            <CreateDailyInspectionModal />
          </Grid>
        </Grid>
      </MDBox>

      <MDBox>
        {loading && <TableSkeleton numberOfLines={10} />}

        {!loading && !error && (
          <DataTable
            table={tableData}
            pagination={pagination}
            filtering={filtering}
            sorting={sorting}
            isSorted={true}
          />
        )}
      </MDBox>

      <QuestionsModal open={questionsModalOpen} onClose={() => setQuestionsModalOpen(false)} />

      {selectedInspectionId && (
        <EditDailyInspectionModal
          open={editModalOpen}
          onClose={handleEditModalClose}
          inspectionId={selectedInspectionId}
        />
      )}
    </DashboardPage>
  );
}
